/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exp_Variability_Index_Short_LabelInputs */

const en_exp_variability_index_short_label = /** @type {(inputs: Exp_Variability_Index_Short_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VI`)
};

const de_exp_variability_index_short_label = /** @type {(inputs: Exp_Variability_Index_Short_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VI`)
};

/**
* | output |
* | --- |
* | "VI" |
*
* @param {Exp_Variability_Index_Short_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const exp_variability_index_short_label = /** @type {((inputs?: Exp_Variability_Index_Short_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exp_Variability_Index_Short_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_exp_variability_index_short_label(inputs)
	return de_exp_variability_index_short_label(inputs)
});